export default {
  edge: 'https://www.microsoft.com/en-gb/windows/microsoft-edge',
  chrome: 'https://www.google.com/chrome/',
  firefox: 'https://www.mozilla.org/en-GB/firefox/new/',
};
